import { Controller } from "@hotwired/stimulus";

// System / Light / Dark segmented control (a radiogroup). Writes the `theme`
// cookie and <html data-theme> immediately. Without JS the buttons submit the
// surrounding form to ThemesController, which sets the cookie server-side.
export default class extends Controller {
  static targets = ["option"];
  static classes = ["selected", "idle"];

  choose(event) {
    event.preventDefault();
    this.apply(event.currentTarget);
  }

  navigate(event) {
    const forward = ["ArrowRight", "ArrowDown"];
    const backward = ["ArrowLeft", "ArrowUp"];
    if (!forward.includes(event.key) && !backward.includes(event.key)) return;

    event.preventDefault();
    const options = this.optionTargets;
    const current = options.indexOf(document.activeElement);
    const step = forward.includes(event.key) ? 1 : -1;
    const next = options[(current + step + options.length) % options.length];
    next.focus();
    this.apply(next);
  }

  apply(option) {
    const value = option.value;
    const root = document.documentElement;
    const forced = value === "light" || value === "dark";

    if (forced) {
      document.cookie = `theme=${value}; path=/; max-age=31536000; SameSite=Lax`;
      root.dataset.theme = value;
    } else {
      document.cookie = "theme=; path=/; max-age=0; SameSite=Lax";
      delete root.dataset.theme;
    }

    const meta = document.querySelector('meta[name="color-scheme"]');
    if (meta) meta.content = forced ? value : "light dark";

    this.optionTargets.forEach((target) => {
      const selected = target === option;
      target.setAttribute("aria-checked", String(selected));
      target.tabIndex = selected ? 0 : -1;
      target.classList.remove(...this.selectedClasses, ...this.idleClasses);
      target.classList.add(...(selected ? this.selectedClasses : this.idleClasses));
    });
  }
}
